import React, { FC, ReactNode, useState } from 'react';
import { useSelector } from 'src/store';
import { Redirect, useLocation } from 'react-router-dom';
import { runtimeConfigs } from 'src/config/runtimeConfigs';

interface Props {
  children: ReactNode;
}

export const GuestGuard: FC<Props> = ({ children }) => {
  const account = useSelector(state => state.account);
  const [firstConfig, setFirstConfig] = useState(false);
  const location = useLocation();

  const searchEnviroment = async () => {
    const enviroment = await runtimeConfigs();

    if (!enviroment && location.pathname !== '/configuracao-inicial') {
      setFirstConfig(true);
    }
  };

  searchEnviroment();

  if (account.user) {
    return <Redirect to="/" />;
  }

  if (firstConfig) {
    return <Redirect to="/configuracao-inicial" />;
  }

  return <>{children}</>;
};
